import * as React from "react";

import { RobotoLogo } from "@/shared/components";
import { Card } from "@/shared/foundation/primitives";

import styles from "./CredentialRequestApproval.module.css";

/** One step of the approval page: the Roboto logo over a card whose title is the page's heading. */
export function CredentialRequestCard({
  title,
  children,
}: {
  title: string;
  children: React.ReactNode;
}) {
  return (
    <>
      <div className={styles.logo}>
        <RobotoLogo />
      </div>
      <Card.Root className={styles.card}>
        <Card.Header>
          <Card.Title level={1}>{title}</Card.Title>
        </Card.Header>
        <Card.Body>{children}</Card.Body>
      </Card.Root>
    </>
  );
}
